import { ReactNode } from 'react';

import { useIntl } from 'react-intl';

import KeyboardShortcuts from 'src/components/keyboard-shortcut-handler';

import { messages } from './keyboard-shortcuts.i18n';

const GROUP_ID = 'global';

type Props = {
  children: ReactNode;
  toggleKeyboardShortcutMenu: (isOpen?: boolean) => void;
  toggleSearchDrawer: (isOpen?: boolean) => void;
};

export const NavigationKeyboardShortcuts = (props: Props) => {
  const { children } = props;
  const { formatMessage } = useIntl();
  const shortcuts = () => [
    {
      id: 'toggle-nav',
      description: formatMessage(messages.toggleNavigationShortcut),
      // the actual side nav toggle behavior is controlled by the global-side-navigation
      // so we don't need any handler here but we do want it to show up in the keyboard shortcut modal.
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      handler: () => {},
      keys: ['Ctrl', '['],
    },
    {
      id: 'toggle-search',
      description: formatMessage(messages.toggleSearchShortcut),
      handler: (e: KeyboardEvent) => {
        // prevent the "/" key input from being entered in the search input
        e.preventDefault();
        props.toggleSearchDrawer();
      },
      keys: '/',
    },
    {
      id: 'toggle-keyboard-shortcut-menu',
      description: formatMessage(messages.toggleKeyboardShortcutMenuShortcut),
      handler: () => {
        props.toggleKeyboardShortcutMenu();
      },
      keys: '?',
    },
  ];

  return (
    <KeyboardShortcuts
      groupId={GROUP_ID}
      groupTitle={formatMessage(messages.shortcutGroupTitle)}
      groupWeight={-100}
      shortcuts={shortcuts()}
    >
      {children}
    </KeyboardShortcuts>
  );
};
